import type { ProviderCategory, ProviderMatch } from './types';

type ProviderDefinition = {
  id: string;
  category: ProviderCategory;
  domains: string[];
  targetAliases: string[];
};

const PROVIDERS: ProviderDefinition[] = [
  { id: 'opentable', category: 'reservation', domains: ['opentable.com', 'opentable.ca', 'opentable.co.uk'], targetAliases: ['opentable', 'open-table'] },
  { id: 'resy', category: 'reservation', domains: ['resy.com', 'widgets.resy.com'], targetAliases: ['resy'] },
  { id: 'tock', category: 'reservation', domains: ['exploretock.com', 'tockify.com'], targetAliases: ['tock'] },
  { id: 'thefork', category: 'reservation', domains: ['thefork.com', 'thefork.pl', 'widget.thefork.com'], targetAliases: ['thefork'] },
  { id: 'dinnerbooking', category: 'reservation', domains: ['dinnerbooking.com', 'dinnerbooking.dk'], targetAliases: ['dinnerbooking', 'dinner-booking'] },
  { id: 'uber_eats', category: 'order_delivery', domains: ['ubereats.com', 'eats.uber.com'], targetAliases: ['ubereats', 'uber-eats', 'uber_eats'] },
  { id: 'doordash', category: 'order_delivery', domains: ['doordash.com', 'order.online'], targetAliases: ['doordash', 'door-dash'] },
  { id: 'grubhub', category: 'order_delivery', domains: ['grubhub.com'], targetAliases: ['grubhub'] },
  { id: 'toast', category: 'order_direct', domains: ['toasttab.com', 'toasttakeout.com'], targetAliases: ['toast', 'toasttab'] },
  { id: 'chownow', category: 'order_direct', domains: ['chownow.com', 'order.chownow.com'], targetAliases: ['chownow', 'chow-now'] },
  { id: 'clover', category: 'order_direct', domains: ['clover.com', 'order.clover.com'], targetAliases: ['clover'] },
  { id: 'square_online', category: 'order_direct', domains: ['square.site', 'squareup.com'], targetAliases: ['square', 'square-online'] },
  { id: 'just_eat_takeaway', category: 'order_delivery', domains: ['pyszne.pl', 'just-eat.dk', 'just-eat.com', 'takeaway.com', 'lieferando.de'], targetAliases: ['pyszne', 'just-eat', 'justeat', 'takeaway', 'lieferando'] },
  { id: 'glovo', category: 'order_delivery', domains: ['glovoapp.com', 'glovo.com'], targetAliases: ['glovo'] },
  { id: 'wolt', category: 'order_delivery', domains: ['wolt.com'], targetAliases: ['wolt'] },
  { id: 'bolt_food', category: 'order_delivery', domains: ['bolt.eu', 'food.bolt.eu'], targetAliases: ['bolt', 'bolt-food', 'bolt_food'] },
  { id: 'google_maps', category: 'directions', domains: ['maps.google.com', 'google.com', 'maps.app.goo.gl', 'goo.gl'], targetAliases: ['google-maps', 'google_maps', 'maps'] },
  { id: 'apple_maps', category: 'directions', domains: ['maps.apple.com'], targetAliases: ['apple-maps', 'apple_maps'] },
  { id: 'instagram', category: 'social', domains: ['instagram.com'], targetAliases: ['instagram', 'ig'] },
  { id: 'facebook', category: 'social', domains: ['facebook.com', 'fb.com'], targetAliases: ['facebook', 'fb'] },
];

export function matchProviderFromHref(href: string | null): ProviderMatch | null {
  if (!href) return null;
  let host = '';
  let path = '';
  try {
    const url = new URL(href, window.location.href);
    host = url.hostname.replace(/^www\./, '').toLowerCase();
    path = url.pathname.toLowerCase();
  } catch {
    return null;
  }

  for (const provider of PROVIDERS) {
    for (const domain of provider.domains) {
      if (host === domain || host.endsWith(`.${domain}`)) {
        if (provider.id === 'google_maps' && !path.includes('/maps') && !host.includes('maps')) continue;
        return { id: provider.id, category: provider.category, confidence: 0.98 };
      }
    }
  }
  return null;
}

export function matchProviderFromTarget(target: string | null): ProviderMatch | null {
  if (!target) return null;
  const normalized = target.toLowerCase();
  for (const provider of PROVIDERS) {
    if (provider.targetAliases.some((alias) => normalized === alias || normalized.startsWith(`${alias}-`))) {
      return { id: provider.id, category: provider.category, confidence: 0.95 };
    }
  }
  return null;
}
